import placeholderImage from "../../../images/placeholder-image.png"
import * as CommonUtilities from "../../../common/utils/CommonUtils.js"

export default function Product(props) {
    let energyCount;
    if (props.data.energyCount !== 0 && props.data.energyCount !== "0" && props.data.energyCount !== "" && props.data.energyCount !== null) {
        energyCount = <div className="mt-2">
                        <span className="badge bg-secondary bg-opacity-50">{props.data.energyCount}kJ</span>
                    </div>
    } else {
        energyCount = <></>
    }

    // Sold Out Badge
    let soldOutBadgeStyle = {
        transform: "rotate(45deg)",
        zIndex: "3",
        minWidth: "200px",
        top: "1rem",
        right: "-4rem"
    }
    let soldOutBadge = props.data.isSoldOut ? 
    <div className="position-relative w-100 d-flex justify-content-end">
        <div className="position-absolute bg-black text-white p-2" style={soldOutBadgeStyle}>
            <small>SOLD OUT</small>
        </div>
    </div> : <></>

    // === begin: Bulk Pricing ===
    let bulkPricingBadge;
    if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
        if (props.data.bulkPricingProductsPriceList.length > 0) {
            bulkPricingBadge = <div className="mt-2">
                                    <span className="badge bg-secondary bg-opacity-50">Buy more, save more</span>
                                </div>
        } else {
            bulkPricingBadge = <></>;
        }
    } else {
        bulkPricingBadge = <></>;
    }
    // === end: Bulk Pricing ===

    // === begin: Product Description ===
    let prodDescElement = <>{props.data.productDescription && <><br /><div>{props.data.productDescription}</div></>}</>
    if (CommonUtilities.StaticFields.PriceType === 'bp8826' && props.data.productDescription && (props.data.productDescription).includes(',')) {
        let prodDescValue = (props.data.productDescription).split(',').join('<br />');
        prodDescElement = <>{props.data.productDescription && <><br /><div dangerouslySetInnerHTML={{__html: prodDescValue}} class="columnsProdDesc"></div></>}</>
    }
    
    // === end: Product Description ===
    
    return (
        <div className="col-sm-6 g-3 g-md-4 d-grid">
            <button type="button" className="btn btn-light p-0 m-0 border d-flex flex-column align-items-start overflow-hidden" 
                data-productid={props.data.productId} 
                data-productcategoryid={props.productCategoryId} 
                onClick={props.data.isSoldOut ? null : props.handleProductMenuClick} 
                disabled={props.data.isSoldOut ? true : false}
                style={{cursor: props.data.isSoldOut ? "not-allowed" : "pointer"}}
            >
                {soldOutBadge}
                <div className="px-1 py-2 rounded-3 row m-0 w-100 h-100">
                    <div className="col-9 col-md-8 text-start d-flex flex-column justify-content-between" style={{wordBreak: "break-word"}}>
                        <div className="pe-2 pe-sm-1">
                            <b>{props.data.productName}</b>
                            {prodDescElement}
                        </div>
                        <div>
                            {energyCount}
                            {bulkPricingBadge}
                        </div>
                    </div>
                    <div className="col-3 col-md-4 position-relative" style={{height: "max-content"}}>
                        <img src={props.data.productImageURL ? props.data.productImageURL : placeholderImage} className="rounded-3 float-end my-2 w-100 shadow-sm" style={{objectFit: "cover", objectPosition: "center center", aspectRatio: "1/1", maxWidth: "300px", minWidth: "70px"}} alt="Product"></img>
                        <div className="position-absolute bg-white py-1 px-3 border border-1 border-secondary-subtle rounded-pill" style={{ bottom: "0px", right: "5px" }} >{CommonUtilities.StaticFields.CurrencySymbol}{props.data.priceInc.toFixed(2)}</div>
                    </div>
                </div>
            </button>
        </div>
    )
}